import template from './mx-shell-nav-item.html';

mxShellNavItemDirective.$inject = ['mx.components.Recursion'];
export function mxShellNavItemDirective(recursion) {
	return {
		bindToController: {
			item: '<mxShellNavItem',
			mxShellNavItemOrigin: '<mxShellNavItemOrigin',
		},
		compile(element) {
			return recursion.compile(element);
		},
		controller: MxShellNavItemCtrl,
		controllerAs: 'vm',
		restrict: 'A',
		scope: {},
		template: template,
	};
}

/**
 * @ngdoc directive
 * @name mx.shell:mxShellNavItem
 * @module mx.shell
 * @restrict 'A'
 * @scope {}
 * @requires <a href="https://material.angularjs.org/latest/api/service/$mdSidenav" target="_blank">$mdSidenav</a>
 * @requires {@ref mx.components.Recursion mx.components.Recursion}
 * @requires {@ref mx.shell.EventService mx.shell.EventService}
 * @requires {@ref mx.shell.RoutingService mx.shell.RoutingService}
 * @requires {@ref mx.shell.NavigationManager mx.shell.NavigationManager}
 * @requires {@ref mx.internationalization mx.internationalization}
 * @requires $mdSidenav
 * @description
 * Presentation of a sidebar navigation item
 *
 * @param {mx.shell.NavigationItem} item= - {@ref mx.shell.NavigationItem Navigation Item model}
 * @usage <li mx-shell-nav-item="item"></li>
 */

MxShellNavItemCtrl.$inject = [
	'$scope',
	'$mdSidenav',
	'mx.app.DeviceService',
	'$timeout',
	'$element',
	'$attrs',
	'$window',
	'mx.shell.NavigationManager',
	'mx.shell.NavigationService',
	'mx.shell.EventService',
	'mx.shell.RoutingService',
];

function MxShellNavItemCtrl($scope, $mdSidenav, deviceService, $timeout, $element, $attrs, $window, navigationManager, navigationService, eventService, routingService) {
	const vm = this;

	vm.NavigationManager = navigationManager;

	eventService.subscribeTo(mx.shell.EventCodes.NavToggled, onNavBarToggled, $scope);

	const _tryShowMoreItemsDebounced = $.debounce(100, _tryShowMoreItems);

	vm.$onInit = () => {
		if (vm.item) {
			// set level
			if (vm.item.level === undefined) {
				vm.item.level = vm.item.parent && vm.item.parent.level !== undefined ? vm.item.parent.level + 1 : 0;
			}

			vm.handleItemClick = _handleItemClick;

			vm.route = vm.item.route;

			vm.htmlClass = `mx-nav-item--${(vm.item ? vm.item.name : '').replaceAll('.', '--')}`;
			vm.item.htmlClass = vm.htmlClass;
			// TODO: why do we need `vm.itemTitleClass` if we have `vm.htmlClass` ???
			// If it's need to use `title` for some reason - why don't just search elements by it's selector and content?
			vm.itemTitleClass = `mx-nav-item--auto-${vm.item.name.toLowerCase().replace('&', '-').split(' ').join('')}`;
		}
	};

	vm.$postLink = () => {
		vm.itemBtnEl = $element.find('.mx-shell-nav-item--btn');
		if (vm.item && (vm.item.childrenDynamicLoader || vm.item.children.length)) {
			vm.itemBtnEl.attr('aria-haspopup', 'true');
			vm.itemBtnEl.attr('aria-expanded', 'false');
		}
	};

	vm.handleArrowClick = _handleArrowClick;
	vm.deviceService = deviceService;
	vm._formatAsHtmlClass = _formatAsHtmlClass;

	$scope.$watchCollection('vm.item.children', (children) => {
		if (Array.isArray(children)) {
			_tryInitShowMore();
		}
	});

	$scope.$watch('vm.item.selected', () => {
		_tryInitShowMore();
		if (vm.item && vm.item.selected !== undefined && (vm.item.childrenDynamicLoader || vm.item.children.length)) {
			vm.itemBtnEl.attr('aria-expanded', !!vm.item.selected);
		}
	});

	return vm;

	function _formatAsHtmlClass(htmlClass) {
		return (htmlClass || 'undefined').split(' ').join('_');
	}

	function _handleArrowClick($event, item) {
		$event.preventDefault();
		$event.stopPropagation();

		if (item.unwrapped) {
			$timeout(() => {
				item.unwrapped = false;
			});
		} else {
			navigationService.loadChildren(item);
			item.unwrapped = true;
		}
	}

	function onNavBarToggled() {
		if (vm.item.selected) {
			vm.item.selected = false;
		}
	}

	function _handleItemClick($event, item) {
		if ($event) {
			$event.preventDefault();
			$event.stopPropagation();
		}

		let itemToBeOpen = item;
		while (!itemToBeOpen.route && itemToBeOpen.children?.length) {
			itemToBeOpen = itemToBeOpen.children[0];
		}

		let handleItemClickPromise = routingService.isCurrent(itemToBeOpen.route, itemToBeOpen.parameters)
			? routingService.reload()
			: navigationService.setCurrentNavigationItem(itemToBeOpen);
		eventService.dispatchEvent(mx.shell.EventCodes.TrackTelemetry, { eventName: `Navigation clicked`, sender: item.id, senderTitle: item.technicalName });

		handleItemClickPromise
			.then(() => {
				eventService.dispatchEvent(mx.shell.EventCodes.NavigationItemClicked, { navigationItem: itemToBeOpen, $event });

				if (deviceService.screenMobile() && itemToBeOpen.route) {
					$mdSidenav('mx-shell-left-sidebar').close();
				}
			})
			.catch(mx.logCatch);

		setTimeout(() => {
			if (item !== itemToBeOpen) {
				$(`.${itemToBeOpen.htmlClass}`).focus();
			}

			// Handle 2nd level item clicking focus move
			if (itemToBeOpen.level > 0 || vm.mxShellNavItemOrigin) {
				setTimeout(() => {
					if ($(document.activeElement).is('.mx-shell-nav-item--level-1')) {
						const nav3rdLevelItem = itemToBeOpen.children?.length ? $('mx-shell-nav-tabs-level md-tab-item.md-active') : [];
						if (nav3rdLevelItem.length) {
							nav3rdLevelItem.focus();
						}
						// prevent 2nd level dropdown menu stay open after clicking/Enter-key press on item from it
						else if (vm.NavigationManager.collapsedMode) {
							$(document.activeElement).blur();
						}
					}
				}, 100);
			} else if ($event.type === 'click') {
				$(document.activeElement).blur();
			}
		}, 100);
	}

	function _tryInitShowMore() {
		vm.__limitTo = 50;
		if (vm.__limitTo < vm.item.children?.length && vm.item.selected) {
			_tryShowMoreItemsDebounced();
			$window.addEventListener('scroll', _tryShowMoreItemsDebounced, true);
		}
	}

	function _tryShowMoreItems() {
		const showMoreBtn = $element.find('.mx-shell-nav-item--show-more');
		if (showMoreBtn.length > 0 && showMoreBtn.offset().top < $($window).height()) {
			showMoreBtn.click();
		} else if (showMoreBtn.length === 0) {
			$window.removeEventListener('scroll', _tryShowMoreItemsDebounced, true);
		}
	}
}
